<template>
  <Multiselect class="form-control"
               :class="isInvalid ? 'is-invalid' : ''"
               v-model="deviceRootSn"
               :placeholder="$t('page.work-order.pump-head-sn')"
               value-prop="root_sn"
               :label="selectLabel"
               @search-change="debouncedSearch"
               @change="currentDeviceChanged"
               :close-on-select="true"
               :searchable="true"
               :create-option="false"
               :can-deselect="canDeselect"
               :can-clear="canClear"
               :options="devices"
  >
    <template #option="{ option, search }">
      <span v-html="highlight(option, search)"></span>
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import _ from "lodash";
import { ref, computed, watchEffect, getCurrentInstance } from 'vue';
import {publicDevices, deviceSearch} from "@/service";

export default {
  props: {
    customerId: {
      type: [String, Number],
      default: null
    },
    snNum: {
      type: [String, Number],
      default: null
    },
    selectedDeviceRootSn: {
      type: String,
      default: null
    },
    canDeselect: {
      type: Boolean,
      default: false
    },
    canClear: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    isSearchCallApi: {
      type: Boolean,
      default: false,
    }
  },

  setup(props) {
    const instance = getCurrentInstance();
    const devices = ref([]);
    const deviceRootSn = ref(null);

    const selectLabel = computed(() => {
      if (props.customerId) {
        return 'label';
      }
      return 'root_sn';
    });

    const clearCurrentSelectSn = () => {
      deviceRootSn.value = null;
    };

    // 一边输入一边调接口查询列表
    const debouncedSearch = _.debounce( function (search) {
      if (!props.isSearchCallApi) {
        return
      }
      getDevices(search);
    }, 500);

    // 获取设备列表
    const getDevices = async (search) => {
      if (!props.customerId && !search) {
        return;
      }

      const param = {
        // type: "1"
      };

      if (props.customerId) {
        param.customer_id = props.customerId;
      } else {
        param.sn = search;
      }

      const getDeviceList = async (param) => {
        try {
          const res = props.customerId ? await publicDevices(param) : await deviceSearch(param);
          return res.payload;
        } catch (err) {
          console.log('获取设备列表出错：', err);
          return [];
        }
      };

      const processDeviceList = (dataList) => {
        if (props.customerId) {
          return dataList.map(({id, name, customer_id, extra_info, repairs, root_sn, group_sn, product_type}) => {
            // const rootSNObj = attributes.find(() => name === this.$t('page.pump_head_serial_number'));
            // const root_sn = rootSNObj ? rootSNObj.value : null;
            const product_list = _.get(extra_info, 'product_list', []);
            const label = `${root_sn}(${product_list.pop()})`;
            return {id, label, name, customer_id, root_sn, group_sn, repairs, product_type};
          }).filter(({root_sn}) => !!root_sn);
        } else {
          return dataList.results;
        }
      };

      const dataList = await getDeviceList(param);
      devices.value = processDeviceList(dataList);
      // console.log('设备列表：', devices.value);
    };

    const currentDeviceChanged = (val) => {
      // console.log('触发select的change，当前设备变化为：', val)
      if (val) {
        deviceRootSn.value = val;
      }

      if (!deviceRootSn.value) {
        // console.log('没有选择设备....')
        instance.emit('changed', {root_sn: null, name: null, group_sn: null, repairs: [], product_type: null});
      } else {
        // console.log('当前设备：', deviceRootSn.value)
        const currentDevice = _.find(devices.value, ['root_sn', deviceRootSn.value]);
        if (!currentDevice) {
          console.error('没有找到sn对应的option:', deviceRootSn.value);
          return;
        }
        // 任何变化
        instance.emit('changed', currentDevice);
      }
    }

    const highlight = (option, search) => {
      if (!search) return option[selectLabel.value]
      const regex = new RegExp(search, 'gi')
      return option[selectLabel.value].replace(regex, match => `<mark>${match}</mark>`)
    }

    watchEffect( async () => {
      if (!props.isSearchCallApi) {
        // 通过customerId获取设备列表时
        if (!props.customerId) {
          // console.log('没有customerId')
          // 没有customerId, 清空设备列表和所选设备
          devices.value = [];
          deviceRootSn.value = null;
        } else {
          // console.log('当前customer:', props.customerId)
          // 改变customerId时，重新获取设备列表，清空所选设备
          await getDevices('');
          deviceRootSn.value = null;
        }
        if(props.snNum){
          deviceRootSn.value = props.snNum;

        }
      }
      if (props.selectedDeviceRootSn) {
        // console.log('当前设备外面传过来的设备：', props.selectedDeviceRootSn)
        deviceRootSn.value = props.selectedDeviceRootSn;
      }

    })


    return {
      devices,
      deviceRootSn,
      selectLabel,
      debouncedSearch,
      highlight,
      clearCurrentSelectSn,
      currentDeviceChanged,
    };
  },

  components: {
    Multiselect,
  },

}
</script>

<style>
mark {
  background-color: #405189;
  color: white;
}
</style>
